import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { ActionPlansContext } from "context/ActionPlansContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { postActionPlanScenario, getActionPlan } from "services/ConfigServices";
import Button from "@mui/material/Button";
import {
  AutocompleteInput,
  AutocompleteInputDroppable,
  CustomSelect,
  CustomSwitch,
  DateInput,
  FloatInput,
  IntInput,
  LocalizationAutocomplete,
  TextInput,
} from "components/Input/Index.js";
import SubmitButton from "components/CustomButtons/SubmitButton";
import { planActions } from "variables/planActions";
import { reclevelData } from "variables/lists/planActions";

function AddScenarioDialog(props) {
  const { closeModal, setLoading, refetch } = props;

  const appContext = useContext(ActionPlansContext);
  const { actionPlans, setActionPlans } = appContext;
  const [newScenario, setNewScenario] = useState({
    name: "",
    code: "",
    description: "",
    order: "",
    feasibility: "",
    grade: "",
    reclevel: "",
    comments: "",
    associatedActions: [],
  });
  const [actionList, setActionList] = useState([]);

  const [buttonDisabled, setButtonDisabled] = useState(true);

  console.log(actionPlans, newScenario);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(e.target);
    setNewScenario((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleActiveChange = (e) => {
    const { name, value } = e.target;
    setNewScenario((prevState) => ({
      ...prevState,
      [name]: value,
      activationdate: new Date().toISOString().slice(0, 10),
    }));
  };

  useEffect(() => {
    setNewScenario({ actionplan: actionPlans.id });
  }, [actionPlans]);

  useEffect(() => {
    actionPlans.actions.map((value) => {
      setActionList((prevState) => [
        ...prevState,
        {
          fileId: value.id,
          fileName: value.parameters.name,
        },
      ]);
    });
  }, [actionPlans]);

  useEffect(() => {
    if (
      newScenario.name !== undefined &&
      newScenario.code !== undefined &&
      newScenario.description !== undefined &&
      newScenario.order !== undefined &&
      newScenario.feasibility !== undefined &&
      newScenario.grade !== undefined &&
      newScenario.reclevel !== undefined &&
      newScenario.comments !== undefined &&
      newScenario.associatedActions !== undefined
    ) {
      if (
        newScenario?.name.length > 0 &&
        newScenario?.code.length > 0 &&
        newScenario?.description.length > 0 &&
        newScenario?.order.length > 0 &&
        newScenario?.feasibility.length > 0 &&
        newScenario?.grade.length > 0 &&
        newScenario?.reclevel.length > 0 &&
        newScenario?.comments.length > 0 &&
        newScenario?.associatedActions.length > 0
      ) {
        setButtonDisabled(false);
      } else {
        setButtonDisabled(true);
      }
    }
  }, [JSON.stringify(newScenario)]);

  const urlPlanAction = getActionPlan(actionPlans.id);

  let url = postActionPlanScenario();

  const handleSubmit = (event) => {
    createActionPlanScenario(event);
    //setLoading(true);
    axios
      .get(urlPlanAction, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        setActionPlans(response.data || []);
      });
    closeModal();
  };

  const createActionPlanScenario = async (event) => {
    console.log(newScenario);

    axios
      .post(url, newScenario, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setNotification("success", "Scénario créé");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleAssociatedfilesChange = (newValue) => {
    let newArray = [];

    for (let i = 0; i < newValue.length; i++) {
      newArray.push({
        fileId: newValue[i].fileId,
        fileName: newValue[i].fileName,
        position: i + 1,
      });
    }

    console.log(newArray);

    setNewScenario((prevState) => ({
      ...prevState,
      associatedActions: newArray,
    }));
  };

  console.log(handleSubmit);

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={6} md={7} lg={7}>
          <TextInput
            inputTitle={planActions.scenarios.name}
            textInput={newScenario.name}
            handleTextInputChange={handleChange}
            name="name"
          />
          <TextInput
            inputTitle={planActions.scenarios.code}
            textInput={newScenario.code}
            handleTextInputChange={handleChange}
            name="code"
          />
          <TextInput
            inputTitle={planActions.scenarios.description}
            textInput={newScenario.description}
            handleTextInputChange={handleChange}
            name="description"
          />
          <IntInput
            inputTitle={planActions.scenarios.order}
            intInput={newScenario.order}
            handleIntInputChange={handleChange}
            name="order"
          />
          <TextInput
            inputTitle={planActions.scenarios.feasibility}
            textInput={newScenario.feasibility}
            handleTextInputChange={handleChange}
            name="feasibility"
          />
          <TextInput
            inputTitle={planActions.scenarios.grade}
            textInput={newScenario.grade}
            handleTextInputChange={handleChange}
            name="grade"
          />
          <CustomSelect
            inputTitle={planActions.scenarios.reclevel}
            selectValue={newScenario.reclevel}
            handleSelectValueChange={handleChange}
            data={reclevelData}
            name="reclevel"
          />
          <TextInput
            inputTitle={planActions.scenarios.comments}
            textInput={newScenario.comments}
            handleTextInputChange={handleChange}
            name="comments"
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={5} lg={5}>
          <AutocompleteInputDroppable
            inputTitle={"Actions associées"}
            selected={newScenario.associatedActions || []}
            list={actionList}
            handleChange={(_, newValue) =>
              handleAssociatedfilesChange(newValue)
            }
            isMultiple
          />
        </GridItem>

        <GridItem xs={12} sm={6} md={7} lg={7}>
          <SubmitButton
            buttonDisabled={buttonDisabled}
            handleSubmit={handleSubmit}
          >
            Ajouter
          </SubmitButton>
        </GridItem>
      </GridContainer>
    </>
  );
}

export default AddScenarioDialog;
